import React from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

export default function Faq() {
  const { settings } = useSelector((s) => s?.Login);
  return (
    <div className="container-fluid profileBox dashboardprofile faqBanner px-0">
     <img src={settings?.faqData?.image?.link || "/images/Community-banner.png"} className="banner_inner" alt="BUYER FAQ’s" />
    <Row>
      <Col lg={12}>
        <h1>Frequently Asked Questions (FAQs)</h1>
      </Col>
    </Row>
  
</div>
  
  );
}
